import React from 'react';
import { Helmet } from "react-helmet";
import './home.style';
import { Home } from './home';

export class Home_Component extends React.Component {
    constructor( props ) {
        super();
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`}</title>
                    <meta property='og:title' content={`Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                    <meta name="description" content={`Наш медицинский портал предлагает полезные сервисы и информацию о врачах и учреждениях здравоохранения в Нижегородской области. На нашем сайте вы найдете подробную информацию о больницах, поликлиниках, врачах, а также сможете пройти медицинские тесты и ознакомиться с рейтингами полезных продуктов питания. Мы также предлагаем свежие новости и другие полезные сервисы, чтобы помочь вам оставаться здоровыми и информированными.`} />
                    <meta name="og:description" content={`Наш медицинский портал предлагает полезные сервисы и информацию о врачах и учреждениях здравоохранения в Нижегородской области. На нашем сайте вы найдете подробную информацию о больницах, поликлиниках, врачах, а также сможете пройти медицинские тесты и ознакомиться с рейтингами полезных продуктов питания. Мы также предлагаем свежие новости и другие полезные сервисы, чтобы помочь вам оставаться здоровыми и информированными.`} />
                </Helmet>
                <Home />
            </>
        );
    }
}